import moment from 'moment';

export default {
  methods: {
    formatDate(date, initialFormat, outputFormat) {
      let dateFormatted = moment(date, initialFormat).format(outputFormat);
      if (dateFormatted === 'Invalid date') {
        dateFormatted = '';
      }
      return dateFormatted;
    },
    formatDateV2(date, initialFormat = 'YYYY-MM-DD', outputFormat = 'DD/MM/YYYY') {
      if (!date) {
        return '';
      }
      return moment(date, initialFormat).format(outputFormat);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/formatDate.js